import Vue from "vue"
import Router from "vue-router"
import index from "../pages/index"
import login from "../pages/login"
import agentadd from "../pages/agentadd"
import dividecard from "../pages/dividecard"
import setCommission from "../pages/setCommission"
import withdraw from "../pages/withdraw"
import header from "../components/header";
import footer from "../components/footer";
import resetpassword from "../pages/resetpassword";
import rebatelist from "../pages/rebatelist";
import bankInfo from "../pages/bankInfo";
import leshuaInfo from "../pages/leshuaInfo";
import yewuyuan from "../pages/yewuyuan";
Vue.use(Router)
const routes = [
  {
    path: "/",
    name: "index",
    meta: {
      requireAuth: true
    },
    components: {
      default: index,
    }
  },{
    path: "/yewuyuan",
    name: "yewuyuan",
    meta: {
      requireAuth: false,
      title:'店铺录入'
    },
    components: {
      default: yewuyuan,
    }
  },{
    path: "/leshuaInfo",
    name: "leshuaInfo",
    meta: {
      requireAuth: true
    },
    components: {
      default: leshuaInfo,
    }
  },{
    path: "/bankInfo",
    name: "bankInfo",
    meta: {
      requireAuth: true
    },
    components: {
      default: bankInfo,
    }
  },{
        path: "/rebatelist",
        name: "rebatelist",
        meta: {
            requireAuth: true
        },
        components: {
            default: rebatelist,
        }
    },{
        path: "/resetpassword",
        name: "resetpassword",
        meta: {
            requireAuth: true
        },
        components: {
            default: resetpassword,
        }
    },{
        path: "/withdraw",
        name: "withdraw",
        meta: {
            requireAuth: true
        },
        components: {
            default: withdraw,
        }
    },
    {
        path: "/login",
        name: "login",
        meta: {
            requireAuth: false
        },
        components: {
            default: login
        }
    },{
        path: "/setCommission",
        name: "setCommission",
        meta: {
            requireAuth: true
        },
        components: {
            default: setCommission
        }
    },
    {
        path: "/agentadd",
        name: "agentadd",
        meta: {
            requireAuth: false
        },
        components: {
            default: agentadd
        }
    },{
        path: "/dividecard",
        name: "dividecard",
        meta: {
            requireAuth: false
        },
        components: {
            default: dividecard
        }
    },
]
const router = new Router({
    routes
})
router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    if (to.meta.requireAuth && !sessionStorage.getItem('agenttoken')) {
        next({
            path: 'login',
            query:to.query
        })
    }else{
        next();
    }
})

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js